import React from "react";
import "../scss/Panel.scss";
import "../scss/bootstrap-custom.scss";

function Panel(props) {
  return (
    <div
      className={`Panel d-flex flex-column ${props.className ||
        ""} d-print-none`}
    >
      {props.title ? <div className="Panel_Title d-flex">{props.title}</div> : null}
      <div className="Panel_Body flex-fill d-flex flex-column">
        {props.children}
      </div>
    </div>
  );
}

Panel.Label = function(props) {
  return (
    <div className={`PanelLabel ${props.className || ""}`}>
      {props.children}
    </div>
  );
};

export default Panel;
